<!-- -->
<template>
  <div :class="{ baidu_search: true, mm: isMobile }">
    <div class="box">
      <div class="title-box">
        <div class="title">百度信息流</div>
        <div class="type">
          根据客户主动搜索的关键词，在用户浏览资讯时，定向展现营销内容
        </div>
      </div>
      <div id="special">
        <div class="specials swiper-wrapper">
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'info_img1.png'" alt="" />
            </div>
            <div class="title">精准触达用户</div>
            <div class="desc">根据客户主动搜索的关键词，精准推荐相关信息</div>
          </div>
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'info_img2.png'" alt="" />
            </div>
            <div class="title">广告即内容</div>
            <div class="desc">
              在百度系资讯流中穿插的原生广告，<br />用户潜移默化接受信息
            </div>
          </div>
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'info_img3.png'" alt="" />
            </div>
            <div class="title">承载亿级流量</div>
            <div class="desc">拥有海量优质内容和媒体资源，网罗全网用户</div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <button class="get" @click="$emit('openDialog')">立即获取专属流量</button>
    </div>
    <div class="box2">
      <div class="title-box">
        <div class="title">广告展现形式</div>
        <div class="type">
          穿插在百度APP、百度首页、贴吧、百度手机浏览器等平台的资讯流中
        </div>
      </div>
      <div class="content">
        <div class="types">
          <div
            :class="{ type: true, active: activeType == 0 }"
            @mouseenter="changeType(0)"
          >
            百度APP
          </div>
          <div
            :class="{ type: true, active: activeType == 1 }"
            @mouseenter="changeType(1)"
          >
            百度贴吧
          </div>
          <div
            :class="{ type: true, active: activeType == 2 }"
            @mouseenter="changeType(2)"
          >
            手机网页版百度首页
          </div>
        </div>
        <div class="desc">
          <div class="desc_content" v-show="activeType == 0">
            <div class="item">
              <img
                src="http://gxbg.pangodso.com/file/info_img5.png"
                alt=""
                class="post"
              />
              <div class="icons icons2">
                <img
                  src="http://gxbg.pangodso.com/file/info_icon5.png"
                  alt=""
                  class="icon"
                  style="max-width: 100%"
                />
                <div class="title">百度APP</div>
                <div class="sub">
                  您的广告将会展现在百度APP<br />信息流资讯当中
                </div>
              </div>
            </div>
          </div>
          <div class="desc_content tieba" v-show="activeType == 1">
            <div class="item" style="max-width: 70%">
              <img
                src="http://gxbg.pangodso.com/file/info_img4.png"
                alt=""
                class="post"
              />
              <div class="icons">
                <img
                  src="http://gxbg.pangodso.com/file/info_icon4.png"
                  alt=""
                  class="icon"
                />
                <div class="title">百度贴吧</div>
                <div class="sub">
                  您的广告将会展现在贴吧推荐信息流<br />
                  和帖子信息流当中
                </div>
              </div>
            </div>
          </div>
          <div class="desc_content home" v-show="activeType == 2">
            <div class="item" style="max-width: 40%">
              <img
                src="http://gxbg.pangodso.com/file/info_img6.png"
                alt=""
                class="post"
              />
              <div class="icons icon3">
                <img
                  src="http://gxbg.pangodso.com/file/info_icon6.png"
                  alt=""
                  class="icon"
                />
                <div class="title">手机网页版百度首页</div>
                <div class="sub">
                  您的广告将会展现在移动端百度首页<br />
                  页推荐信息流当中
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "@/util/config";
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  data() {
    return {
      URL,
      activeType: 0,
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  mounted() {
    if (this.isMobile) {
      this.initSpecial();
    }
  },
  methods: {
    initSpecial() {
      new window.Swiper("#special", {
        // loop: true,
        centeredSlides: true,
        slidesPerView: 1.5,
        pagination: {
          el: "#special .swiper-pagination",
        },
      });
    },
    changeType(type) {
      this.activeType = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.box {
  margin-top: 100px;
}
.title-box {
  text-align: center;

  .title {
    color: #0d0d0d;
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 1px;
  }
  .type {
    color: #6e7685;
    letter-spacing: 6px;
    margin-top: 30px;
  }
}
.description {
  width: 1200px;
  font-size: 15px;
  margin: 40px auto 0;
  letter-spacing: 2px;
  line-height: 30px;
}
.float {
  width: fit-content;
  position: relative;
  margin: 50px auto 0;

  .center {
    width: 600px;
  }
  .out {
    position: absolute;
    display: flex;
    align-items: flex-start;

    .icon {
      width: 73px;
    }
    .text {
      margin-left: 15px;
      margin-top: 10px;

      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        margin-top: 5px;
        color: #6e7685;
        line-height: 25px;
        letter-spacing: 2px;
      }
    }
  }
}
.specials {
  width: 1200px;
  margin: 30px auto 0;
  display: flex;
  justify-content: space-between;

  .special {
    width: 32%;
    text-align: center;

    .post {
      width: 100%;
      height: 314px;
      overflow: hidden;

      &:hover {
        img {
          transform: scale(1.1);
        }
      }
      img {
        width: 100%;
        height: 100%;
        display: block;
        transition: 0.5s;
      }
    }
    .title {
      font-size: 20px;
      margin-top: 15px;
    }
    .desc {
      color: #6e7685;
      margin-top: 15px;
      line-height: 26px;
    }
  }
}
.get {
  width: 300px;
  height: 50px;
  margin: 70px auto;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  border-radius: 10px;
  background-color: $theme;
  color: #fff;
  display: block;
}

.box2 {
  background-color: #f5f7fa;
  padding: 80px 0 180px;

  .content {
    width: 1200px;
    margin: 90px auto 0;
    display: flex;

    .types {
      .type {
        width: 250px;
        height: 70px;
        border: 1px solid #eaecee;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 70px;
        cursor: pointer;
        position: relative;

        &:hover {
          color: $theme;

          &::after {
            display: block;
          }
        }

        &::after {
          content: "";
          display: none;
          width: 0;
          height: 0;
          border-width: 8px;
          border-style: solid;
          border-color: transparent transparent transparent #5f84de;
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
        }
        & + .type {
          margin-top: 30px;
        }
      }
      .active {
        color: $theme;
        background-color: #eaecee;
        box-shadow: 0 16px 16px rgba($color: $theme, $alpha: 0.11);

        &::after {
          display: block;
        }
      }
    }

    .desc {
      flex-grow: 1;
      margin-left: 100px;

      .desc_content {
        display: flex;
        animation: fadeIn 0.5s linear;

        .item {
          position: relative;

          & + .item {
            margin-left: 50px;
          }
          .post {
            max-width: 100%;
          }
          .icons {
            text-align: right;
            position: absolute;
            right: -153px;
            bottom: -153px;
          }
          .icons2 {
            right: 80px;
            bottom: 55px;
          }
          .icon3 {
            right: -296px;
            bottom: 42px;
          }
          .icon {
            width: 100px;
          }
          .title {
            font-size: 25px;
            margin-top: 10px;
          }
          .sub {
            color: #6e7685;
            line-height: 26px;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.mm {
  .box {
    margin-top: 60px;
  }
  .title-box {
    .title {
      font-size: 22px;
    }
    .type {
      padding: 0 10px;
      font-size: 15px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
  }
  .description {
    width: 100%;
    padding: 0 10px;
    line-height: 1.5;
    box-sizing: border-box;
    font-size: 14px;
    letter-spacing: 1px;
  }
  #special {
    overflow: hidden;
    position: relative;
    padding-bottom: 30px;

    :deep(.swiper-slide) {
      transform: scale(0.9);
      z-index: 10;
    }
    :deep(.swiper-slide-active) {
      transform: scale(1);
      z-index: 10;
    }
  }
  .specials {
    width: 100%;

    .special {
      width: 100%;
      margin-bottom: 10px;

      .post {
        height: 204px;
      }
      .title {
        font-size: 18px;
        margin-top: 10px;
      }
      .desc {
        font-size: 14px;
        margin-top: 0;
        line-height: 1.5;
      }
    }
  }
  .get {
    width: 60%;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    margin: 20px auto;
  }
  .box2 {
    padding-bottom: 40px;

    .content {
      width: 100%;
      margin-top: 40px;
      flex-direction: column;

      .types {
        display: flex;

        .type {
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          width: unset;
          font-size: 13px;

          & + .type {
            margin-top: 0;
          }
        }
        .active::after {
          top: unset;
          left: 50%;
          bottom: -30px;
          transform: translateX(-50%) rotate(90deg);
        }
      }
      .desc {
        margin-left: 0;
        margin-top: 60px;

        .desc_content {
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;
          max-width: 100% !important;
          flex-direction: row !important;

          .item {
            & + .item {
              margin-top: 0 !important;
              margin-left: 8px !important;
            }
            .icons2 {
              right: 10px;
              bottom: 30px;

              .icon {
                width: 70px;
              }
            }
            .title {
              font-size: 18px;
              margin-top: 10px;
            }
            .sub {
              width: auto;
              margin-top: 5px;
              line-height: 1.2;
            }
          }
        }
        .tieba {
          .item {
            max-width: 100% !important;
          }
          .icons {
            margin-top: 10px;
            text-align: center;
            position: static;

            .icon {
              width: 70px;
            }
          }
        }
        .home {
          .item {
            max-width: 100% !important;
            display: flex;
            align-items: flex-end;

            .post {
              max-width: 35%;
            }
            .icon3 {
              width: 65%;
              position: static;

              .icon {
                width: 70px;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .float .center {
    width: 500px;
  }
  .float .out .text .desc {
    font-size: 14px;
  }
  .description {
    width: 1000px;
  }
  .box2 .content {
    width: 1000px;

    .types .type {
      width: 200px;
      font-size: 20px;
    }
    .desc .desc_content .item {
      .title {
        font-size: 20px;
      }
      .sub {
        font-size: 14px;
      }
    }
  }
}
</style>
